var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popover__container"},[_vm._t("icon",function(){return [_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/images/1/ques.png"),"alt":""}})]}),_c('div',{staticClass:"popover",class:[
    {left: _vm.placement === 'left'},
    {top: _vm.placement === 'top'},
    {bottom: _vm.placement === 'bottom'},
    {right: _vm.placement === 'right'},
  ]},[_vm._m(0),_c('div',{staticClass:"popover__content"},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])])],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popover__arrow"},[_c('span',{staticClass:"popover__arrow-content"})])
}]

export { render, staticRenderFns }